/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var addCartVariant = $(".add_to_cart_variant_button");
var qtyVariant = $(".quantity-variant .qty-variant");
$(".increase.q__up").unbind("click");
$(".increase.q__up").click(function() {
  var p_id = $(this).data("product_id");
  var q_value = parseInt($(".qty-" + p_id).val()) + 1;
  $(".qty-" + p_id).val(q_value);
  if (qtyVariant.length > 0) {
    var r_disabled = false;
    qtyVariant.each(function() {
      var qtyVariantVal = parseInt($(this).val());
      var variant_id = $(this).data("variant_id");
      if (qtyVariantVal != 0) {
        r_disabled = true;
      }
    });
    if (r_disabled) {
      addCartVariant.removeClass("button-disabled"); 
    } else {
      !addCartVariant.hasClass("button-disabled") &&
        addCartVariant.addClass("button-disabled");
    }
  }
});
$(".decrease.q__down").unbind("click");
$(".decrease.q__down").click(function() {
  var p_id = $(this).data("product_id");
  var q_value = parseInt($(".qty-" + p_id).val());
  if (qtyVariant.length > 0) {
    if (q_value > 0) {
      $(".qty-" + p_id).val(q_value - 1);
    }
    var r_disabled = false;
    qtyVariant.each(function() {
      var qtyVariantVal = parseInt($(this).val());
      var variant_id = $(this).data("variant_id");
      if (qtyVariantVal != 0) {
        r_disabled = true;
      }
    });
    if (r_disabled) {
      addCartVariant.removeClass("button-disabled");
    } else {
      !addCartVariant.hasClass("button-disabled") &&
        addCartVariant.addClass("button-disabled");
    }
  } else {
    if (q_value > 1) {
      $(".qty-" + p_id).val(q_value - 1);
    }
  }
});
$(".add_to_cart_variant_button").length > 0 &&
  $(".add_to_cart_variant_button").unbind("click"), $(
  document
).on("click", ".add_to_cart_variant_button", function() { 
  var self = $(this);
  if (self.hasClass("button-disabled")) {
    console.log("can not click");
  } else {
    Shopify.queue = [];
    jQuery('.qty-variant').each(function() {
      Shopify.queue.push({
        variantId: jQuery(this).data('variant_id'),
        quantity: parseInt(jQuery(this).val(), 10) || 0
      });
    });
    Shopify.moveAlong = function() {
      // If we still have requests in the queue, let's process the next one.
      //console.log(Shopify.queue);
      if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        var ajax = $.ajax({
          type: "POST",
          url: "/cart/add.js",
          async: !0,
          cache: !1,
          data: {quantity: request.quantity, id:request.variantId},
          dataType: "json",
          beforeSend: function() {
            self.addClass("loading");
          },
          complete: function(S) {
            console.log("complete");
          },
          error: function(result) {
            var response = $.parseJSON(result.responseText),
                message = response.message + ": " + response.description;
            alert(message);
          },
          success: function(result) {
            console.log("success");
            /*
                var I = [{ product_url: result.url, product_name: result.title }];
                $.notify(
                  {
                    message: $("<div>")
                    .append($("#cart_success").tmpl(I).clone())
                    .html(),
                    target: "_blank"
                  },
                  {
                    type: "success",
                    showProgressbar: !0,
                    z_index: 2031,
                    mouse_over: "pause",
                    placement: { from: "top", align: window.rtl ? "left" : "right" }
                  }
                ), */ Shopify.getCart(function(T) {
                  window.location.href = "/cart";
                });
            Shopify.moveAlong();
          }
        });
      }
      // If the queue is empty, we will redirect to the cart page.
      else {
        if(window.shopping_cart_ajax) { window.location.href = "/cart"}
      }
    };
    Shopify.moveAlong();
  }
  return false;
});

// $(document).ready(function(){
//   $('.sidebar_filter').sticksy({
//     topSpacing: 70
//   });
// });